/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

  var gallery_containers = document.querySelectorAll('.gallery-container');

  if(gallery_containers) {
    gallery_containers.forEach((gallery_container) => {
      const gallery_slider = gallery_container.querySelector('.gallery-slider'),
            in_sidebar = gallery_container.closest('.content-sidebar-container');

      var slider;

      if(in_sidebar) {
        slider = new Splide(gallery_slider, {
          type: 'slide',
          arrows: 'slider',
          pagination: false,
          perPage: 2,
          gap: 20,
          breakpoints: {
            1080: {
              perPage: 1
            },
            1030: {
              perPage: 2
            },
            600: {
              perPage: 1
            }
          }
        });
      } else {
        slider = new Splide(gallery_slider, {
          type: 'slide',
          arrows: 'slider',
          pagination: false,
          perPage: 3,
          gap: 20,
          breakpoints: {
            1030: {
              perPage: 2
            },
            600: {
              perPage: 1
            }
          }
        });
      }

      // $('.carousel-slider').slick({
      //   adaptiveHeight: true,
      //   prevArrow: '<span class="slick-prev slick-arrow"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      //   nextArrow: '<span class="slick-next slick-arrow"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      // });

      slider.mount({ TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag });
    });
  }
}());
